import React, { useState,useEffect } from "react";
import styles from "./index.module.less";
import { observer } from 'mobx-react-lite';
import getProductStatus from "@/components/Pages/Finance/_hook/getProductStatus";
import { Switch,Modal,message } from "antd";
import { post_autoSubscribe } from '@/api/v4/finance';
import closePng from "@/assets/images/home/closePng.png";
import { Hooks } from "@xt/xtbase";
const {useTranslation} = Hooks;

export default observer(({financialProducts=[],currentProduct=null,onChange={}}) => {
  const t = useTranslation();

  if(!currentProduct)
    return <></>

  const [showModal, setShowModal] = useState(0);

  const closeModal = ()=>{
    setShowModal(0);
  }

  var currency = (currentProduct.currency || "").toUpperCase();

  return <>
    <Switch className={styles.autoSubscribe} checked={currentProduct.autoEnable} onChange={(checked) => {
      setShowModal(checked ? 1 : 2);
      return;
    }} />
    <Modal wrapClassName={styles.autoSubscribeModal} open={showModal} width={window.innerWidth < 420 ? window.innerWidth - 20 : 400} centered={true} maskClosable={false} title={
        <div className={styles.headerDiv}>
          <p className={styles.headerTitle}>{(showModal == 1 ? t("finance.autoOpen") : t("finance.autoClose"))+" - "+currency}</p>
          <img className={styles.closeIcon} src={closePng} onClick={() => closeModal() } />
        </div>
      } closeIcon={false} footer={null} >
        <p className={styles.bodyContent}>{showModal == 1 ? t("finance.autoTip") : t("finance.autoCloseAsk")}</p>
        <div className={styles.btnDiv}>
          <p onClick={() => closeModal() } >{t("home.cancel")}</p>
          <p onClick={() => {
            var checked = (showModal == 1);
            post_autoSubscribe({
              enabled: checked,
              productId: currentProduct.id
            }).then((data) => {
              if(checked)
                message.success(t("finance.autoOpened",[currency]));
              else
                message.warning(t("finance.autoClosed",[currency]));
              currentProduct.autoEnable = checked;
              if (financialProducts) {
                var product = null;
                var list = [];
                for (var i in financialProducts) {
                  var item = financialProducts[i];
                  if (item.id == currentProduct.id) {
                    item.autoEnable = checked;
                    product = {...item};
                  }
                  list.push(item);
                }
                onChange(list,product);
              }
            })
            closeModal();
          } } >{t("finance.confirm")}</p>
        </div>
    </Modal>
  </>;
});